import SeoHead from "@/components/SeoHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import LocalFaqSection from "./components/LocalFaqSection";

const localServices = [
  {
    icon: "ri-home-4-line",
    title: "Pose de carrelage à Martigny",
    desc: "Pose de carrelage à Martigny et dans les communes voisines. Grands formats, imitation bois, pierre naturelle — on s'adapte à la surface et au budget.",
  },
  {
    icon: "ri-drop-line",
    title: "Rénovation salle de bain à Martigny",
    desc: "Rénovation de salle de bain à Martigny. On démonte, on refait les installations si besoin, on pose le carrelage, on monte le mobilier — et ça fonctionne.",
  },
  {
    icon: "ri-water-flash-line",
    title: "Douche italienne à Martigny",
    desc: "Douche italienne à Martigny. Receveur encastré, siphon discret, carrelage antidérapant. Design simple, fonctionnement sans faille.",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Faïence & mosaïque à Martigny",
    desc: "Faïence et mosaïque à Martigny. Crédences de cuisine, habillages de salle de bain — on choisit les matériaux en fonction de l'usage et de l'esthétique recherchée.",
  },
  {
    icon: "ri-sun-line",
    title: "Carrelage extérieur à Martigny",
    desc: "Terrasses et espaces extérieurs à Martigny. Carrelage technique qui résiste au gel et aux UV du Valais. On pose pour que ça dure.",
  },
];


const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Accueil",
      "item": "https://carreaux-bat.ch/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Martigny",
      "item": "https://carreaux-bat.ch/martigny"
    }
  ]
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Carrelage et Rénovation à Martigny, Valais",
  "description": "Pose de carrelage, rénovation de salle de bain et douche italienne à Martigny et dans les communes voisines Fully, Saxon, Charrat. Artisan carreleur en Valais.",
  "url": "https://carreaux-bat.ch/martigny",
  "mainEntity": {
    "@type": "LocalBusiness",
    "name": "Carreaux-Bat Valais",
    "telephone": "+41 77 511 75 52",
    "areaServed": {
      "@type": "City",
      "name": "Martigny",
      "containedInPlace": {
        "@type": "AdministrativeArea",
        "name": "Valais"
      }
    }
  }
};

export default function MartignyPage() {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Entreprise de Carrelage & Carreleur à Martigny à Proximité | Carreaux-Bat Valais"
        description="Vous cherchez un carreleur à proximité de Martigny ? Entreprise de carrelage et société de carrelage à Martigny, Valais. Service de carrelage par carreleur près de chez vous à Martigny, Fully, Saxon, Charrat. Pose de carrelage, douche italienne, faïence, terrasse. Devis gratuit."
        keywords="carreleur à proximité de Martigny, entreprise de carrelage à proximité de Martigny, société de carrelage à proximité de Martigny, carreleur près de chez moi Martigny, entreprise de carrelage près de chez vous Martigny, service de carrelage à proximité Martigny, entreprise de carrelage Martigny, société de carrelage Martigny, service de carrelage Martigny, carreleur Martigny, pose de carrelage Martigny, rénovation salle de bain Martigny, douche italienne Martigny, carrelage Fully, faïence Martigny Valais, artisan carreleur Saxon"
        canonical="https://carreaux-bat.ch/martigny"
        ogTitle="Carrelage & Rénovation à Martigny à Proximité — Artisan Carreleur en Valais"
        ogDescription="Vous cherchez un carreleur à proximité de Martigny ? Pose de carrelage, rénovation salle de bain et douche italienne à Martigny et environs. Devis gratuit sur place."
        ogImage="/images/martigny-hero.jpg"
        geoPosition="46.1028;7.0736"
        geoPlacename="Martigny, Valais, Suisse"
        geoRegion="CH-VS"
      schema={{
        "@context": "https://schema.org",
        "@graph": [webPageSchema, breadcrumbSchema]
      }}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <img
          src="/images/martigny-hero.jpg"
          alt="Carrelage Martigny Valais"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block mb-4 px-4 py-1.5 bg-amber-700/80 text-white text-xs font-medium tracking-widest uppercase rounded-full">
            Ville Romaine & Culturelle
          </span>
          <h1 className="text-5xl font-bold text-white mb-4">Entreprise de Carrelage & Carreleur à Martigny</h1>
          <p className="text-white/70 max-w-xl mx-auto text-sm leading-relaxed">
            Martigny et ses alentours — Fully, Saxon, Charrat — on y travaille régulièrement. Des vieilles pierres du centre aux constructions neuves de la Bâtiaz.
          </p>
          <div className="flex items-center justify-center gap-2 mt-6 text-sm text-white/50">
            <Link to="/" className="hover:text-amber-400 transition-colors">Accueil</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Martigny</span>
          </div>
        </div>
      </section>

      {/* Description longue */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Martigny, Valais</span>
              <h2 className="mt-2 text-3xl font-bold text-stone-900 mb-6">Martigny, carrefour historique du Valais</h2>
              <div className="space-y-4 text-sm text-stone-500 leading-relaxed">
                <p>
                  Martigny est une ville d&apos;environ 18 000 habitants située à la confluence du Rhône et de la Drance, à l&apos;entrée du Valais. À 471 mètres d&apos;altitude, elle occupe une position stratégique historique qui remonte à l&apos;époque gallo-romaine, lorsque la cité de Octodurus était un important carrefour commercial.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Votre carreleur à Martigny — Pose de carrelage et faïence</h3>
                <p>
                  La ville est un véritable condensé d&apos;histoire et de culture. Elle abrite la Fondation Pierre Gianadda, l&apos;un des plus grands musées de Suisse, réputé pour ses expositions d&apos;art impressionniste et sa collection de sculptures en plein air. Les ruines romaines du temple de Martigny-Bourg et l&apos;amphithéâtre témoignent du riche passé antique de la cité. Chaque hiver, le Marché de Noël de Martigny attire des milliers de visiteurs dans une ambiance féerique au cœur de la vieille ville.
                </p>
                <p>
                  Martigny est également le point de départ vers les célèbres cols alpins : le Grand-Saint-Bernard, emprunté depuis l&apos;Antiquité, et le col de la Forclaz, qui mène au pays du Mont-Blanc. La région est connue pour ses vignobles de Fully et Saxon, qui produisent d&apos;excellents vins valaisans sur des terroirs ensoleillés et bien exposés.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Entreprise de carrelage à Martigny — Rénovation salle de bain et douche italienne</h3>
                <p>
                  Sur le plan immobilier, Martigny offre un mélange fascinant d&apos;architectures. Le centre historique regorge de bâtisses anciennes avec des intérieurs chargés de cachet, tandis que les quartiers périphériques comme La Bâtiaz et le Manoir connaissent un essor résidentiel moderne. De nombreux propriétaires font appel à nos services pour rénover des salles de bain dans des appartements anciens ou pour installer du carrelage design dans des constructions neuves.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Service de carrelage à Martigny, Fully et Saxon</h3>
                <p>
                  Notre équipe intervient à Martigny et dans les communes voisines : Fully, Saxon, Bovernier, Charrat. On connaît les particularités des constructions locales, qu&apos;il s&apos;agisse de vieilles pierres à isoler ou de bétons modernes à habiller. Envoyez-nous un message, on vient vous voir dans le secteur de Martigny.
                </p>
              </div>
            </div>
            <div>
              <div className="relative rounded-lg overflow-hidden h-96 mb-6">
                <img
                  src="/images/martigny-hero.jpg"
                  alt="Réalisation carrelage Martigny"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">18 000</p>
                  <p className="text-xs text-stone-500 mt-1">Habitants à Martigny</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">471 m</p>
                  <p className="text-xs text-stone-500 mt-1">Altitude</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">48h</p>
                  <p className="text-xs text-stone-500 mt-1">Délai d&apos;intervention</p>
                </div>
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">Gratuit</p>
                  <p className="text-xs text-stone-500 mt-1">Devis sur place</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services locaux */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Prestations locales</span>
            <h2 className="mt-3 text-3xl font-bold text-stone-900">Nos services à Martigny</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {localServices.map((service) => (
              <div key={service.title} className="bg-white rounded-lg p-6 border border-stone-100 hover:border-amber-200 transition-colors">
                <div className="w-11 h-11 flex items-center justify-center bg-amber-50 rounded-lg mb-4">
                  <i className={`${service.icon} text-amber-700 text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-stone-900 mb-2">{service.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{service.desc}</p>
              </div>
            ))}
            <div className="bg-amber-700 rounded-lg p-6 flex flex-col justify-between">
              <div>
                <h3 className="text-base font-semibold text-white mb-2">Devis gratuit à Martigny</h3>
                <p className="text-sm text-amber-100 leading-relaxed">Envoyez-nous un message, on vient vous voir à Martigny et dans les environs. On regarde, on discute, on vous dit franchement ce qu'on peut faire.</p>
              </div>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-white text-amber-700 text-sm font-medium rounded-full hover:bg-amber-50 transition-colors whitespace-nowrap"
              >
                Demander un devis
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-stone-900">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Votre projet à Martigny</h2>
          <p className="text-stone-400 text-sm mb-8 max-w-xl mx-auto">
            De la place centrale de Martigny aux hameaux de Fully et Saxon, on connaît les constructions du secteur. Les vieilles bâtisses avec leurs murs épais, les nouvelles résidences — on s'adapte à chaque chantier.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-amber-700 text-white font-medium rounded-full hover:bg-amber-600 transition-colors whitespace-nowrap"
            >
              Devis gratuit à Martigny
            </Link>
            <a
              href="tel:+41775117552"
              className="px-8 py-3.5 border border-stone-600 text-stone-300 font-medium rounded-full hover:border-amber-600 hover:text-amber-400 transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              +41 77 511 75 52
            </a>
          </div>
        </div>
      </section>

      <LocalFaqSection
        city="Martigny"
        faqs={[
          {
            question: "Travaillez-vous à Martigny-Bourg et dans le centre historique ?",
            answer: "Oui, on intervient dans le centre historique de Martigny-Bourg et dans les vieilles bâtisses du secteur. On connaît les contraintes des constructions anciennes : murs épais, sols irréguliers, et parfois des accès étroits. On sait s'adapter tout en respectant le cachet des lieux."
          },
          {
            question: "Faites-vous des interventions à Fully et Saxon ?",
            answer: "Oui, on intervient à Martigny et dans les communes voisines : Fully, Saxon, Bovernier, Charrat. On connaît les routes et les particularités de chaque secteur. Pas de frais de déplacement supplémentaires dans ce rayon."
          },
          {
            question: "Quels types de carrelage sont adaptés aux vieilles pierres de Martigny ?",
            answer: "Les constructions anciennes de Martigny demandent des matériaux qui respirent et résistent aux variations d'humidité. On recommande des carrelages en grès cérame ou en pierre naturelle, avec des joints adaptés. Pour les sols anciens, on fait souvent un ragréage préalable pour assurer une pose durable."
          },
          {
            question: "Combien de temps dure une pose de carrelage à Martigny ?",
            answer: "Pour une salle de bain standard, comptez 3 à 5 jours de pose. Pour une pièce de vie de 30m², environ 4 à 6 jours. Cela dépend de la complexité des découpes, du type de carrelage choisi, et de l'état du support. On vous donne un timing précis lors du devis."
          },
          {
            question: "Faites-vous des douches italiennes dans les appartements anciens de Martigny ?",
            answer: "Oui, et c'est un de nos projets préférés. Dans les appartements anciens de Martigny, on adapte la douche italienne aux contraintes existantes : hauteur sous plafond, évacuations existantes, et étanchéité des vieilles structures. Le résultat est moderne et fonctionnel, tout en respectant l'âme du lieu."
          },
          {
            question: "Comment entretenir un carrelage extérieur en Valais ?",
            answer: "Le climat valaisan est exigeant : UV intenses, gel en hiver, neige. On recommande un nettoyage régulier à l'eau claire, l'évitement des produits acides agressifs, et un traitement hydrofuge tous les 2 à 3 ans pour les terrasses. Un bon carrelage bien posé demande peu d'entretien au quotidien."
          }
        ]}
      />

      <Footer />
    </div>
  );
}
